<div class="container">
  <img src="imgs/icon.png" class="logo-icon">
  <div class="title">
    MyMindLog
  </div>
  <div class="sub-title">
    {{'forgot_password.forgot' | translate}}
  </div>
  <div class="form-container">
    <form [formGroup]="forgotForm" class="form">
      <app-input 
        [label]="'labels.email' | translate"
        [placeholder]="'placeholders.registered_email' | translate"
        [formControl]="emailControl"
        type="email"
      ></app-input>
    </form>

    <div class="actions-container">
      <app-button 
        [buttonLabel]="'buttons.cancel' | translate"
        [buttonType]="BUTTON_TYPES.OUTLINED" 
        [buttonDisabled]="false"
        (click)="cancel()">
      </app-button>
      
      <app-button
        [buttonLabel]="'buttons.recover' | translate"
        [buttonType]="BUTTON_TYPES.REGULAR" 
        [buttonDisabled]="isFormInvalid()"
        (click)="requestReset()">
      </app-button>
    </div>
    
  </div>
</div>